<template>
  <div class="film-component-wraper" :class="{ 'modal-ui-active': modalActive }">
    <div class="video">
      <video width="1280" height="720" id="playerVideo" controls crossorigin playsinline :data-poster="getPoster()">
        <source :src="videoFile" type="video/mp4" :key="componentKey" />
        Your browser does not support the video tag.
      </video>
      <div class="video-title">
        <span v-html="this.film.item.title"></span>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';

import Plyr from 'plyr';
import 'plyr/dist/plyr.css';

import { getAudioURL } from '__mainSrcDir/Utils/DB/get';
import { AUDIO_NAMES } from '__mainSrcDir/Utils/DB/configDB';

export default {
  name: 'tr-film',
  props: [],
  data: function () {
    return {
      videoFile: '',
      publicPath: process.env.BASE_URL,
      componentKey: true,
    };
  },
  beforeDestroy: function () {
    this.$store.commit('GALLERY_DEACTIVATE');
    this.$store.commit('CHANGE_FULLSCREEN_FILM_ACTIVE', false);
  },

  mounted: function () {
    const player = new Plyr(document.getElementById('playerVideo'));
    var options = _.cloneDeep(this.film.item);
    var that = this;
    console.log(options.poster);
    if (options.poster) {
      options.poster = require(`__staticDir/${this.$store.getters.multibookType}/${options.poster}`);
    } else {
      let posterSrc = `films/base.png`;
      options.poster = require(`__staticDir/${this.$store.getters.multibookType}/${posterSrc}`);
    }
    if (options.m4v) {
      let videoSrc = options.m4v;
      options.m4v = require(`__staticDir/${this.$store.getters.multibookType}/${videoSrc}`);
    }
    if (process.env.VUE_PWA) {
      this.changeFilm(options.m4v);
    } else {
      this.videoFile = options.m4v;
      this.forceRerender();
    }
  },
  methods: {
    getPoster() {
      let poster;
      if (this.film.item.poster) {
        poster = require(`__staticDir/${this.$store.getters.multibookType}/${this.film.item.poster}`);
      } else {
        let posterSrc = `films/base.png`;
        poster = require(`__staticDir/${this.$store.getters.multibookType}/${posterSrc}`);
      }
      return poster;
    },
    changeFilm(_name) {
      let name = _name;
      if (!name) {
        name = _.sample(VIDEO_NAMES);
      }
      return getVideoURL(name).then((videURL) => {
        this.videoFile = videURL;
        this.forceRerender();
      });
    },
    forceRerender() {
      this.componentKey = !this.componentKey;
    },
  },
  computed: {
    film() {
      return this.$store.getters.filmData;
    },
    modalActive() {
      return this.$store.getters.modalActive;
    },
  },
};
</script>

<style lang="scss">
.film-component-wraper {
  position: absolute;
  pointer-events: auto;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  .video {
    display: flex;
    flex-direction: column;
    max-width: 1280px;
    // position: relative;
    .video-title {
      padding-top: 1vmin;
      padding-bottom: 1vmin;
      font-size: 2vmin;
    }
    .plyr--pip-supported [data-plyr='pip'] {
      display: none;
    }
  }
}
#magic-button {
  pointer-events: auto;
  // position: absolute;
  // opacity: 1;
  // z-index: 1003;
}
</style>
